import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "dtt8kkai",
    dataset: "production"
})